import { CSSObject } from '@chakra-ui/react';

export const ModalOverlay = (): CSSObject => ({
  bg: 'rgba(18, 55, 81, .7)', // Bespoke
});
